// closing-year-end-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  "err.yearClosing.unbalancedCarryforward": "Året kan ikke avsluttes: resultatet er ikke fullt disponert eller balansen til neste år er ubalansert. Kontroller posteringene.",
  "err.yearClosing.taxProvisionMismatch": "Bokført betalbar skatt avviker fra det oppdaterte grunnlaget. Kontroller skatteavsetningen før avslutning.",

  "clo.importedArchiveTitle": "Importert årsgrunnlag",
  "clo.importedArchiveHelp": "Året vises som historikk fra tidligere system. Kontroller tallene i rapportene. Ny årsavslutning krever komplett bokføringsgrunnlag. Importen dokumenterer ikke innlevering.",
  "clo.importedArchiveResult": "Resultat for {year}: {amount}",

  'cye.notAvailableYet': 'Årsavslutning er ikke tilgjengelig ennå.',
  'cye.nuf.saved': 'NUF-gjennomgangen er lagret.',
  'cye.nuf.saveFailed': 'Kunne ikke lagre NUF-gjennomgangen.',
  'cye.nuf.headOfficeName': 'Hovedforetakets navn',
  'cye.nuf.foreignRegistrationId': 'Utenlandsk registreringsnummer',
  'cye.nuf.homeCountry': 'Hjemland (ISO-kode)',
  'cye.nuf.homeLegalForm': 'Selskapsform i hjemlandet',
  'cye.nuf.framework': 'Regnskapsrammeverk',
  'cye.nuf.frameworkNorwegian': 'Norsk god regnskapsskikk',
  'cye.nuf.frameworkHomeReconciled': 'Hjemlandets regler, avstemt til norsk filial',
  'cye.nuf.taxNexus': 'Norsk skatteposisjon',
  'cye.nuf.taxNexusTaxable': 'Skattepliktig virksomhet i Norge er bekreftet',
  'cye.nuf.taxNexusExempt': 'Unntak er faglig bekreftet',
  'cye.nuf.taxReturnDuty': 'Skattemelding i Norge',
  'cye.nuf.annualAccountsDuty': 'Årsregnskap for norsk filial',
  'cye.nuf.foreignAccountsAttachment': 'Utenlandsk årsregnskap som vedlegg',
  'cye.nuf.mustFile': 'Skal leveres',
  'cye.nuf.exemptAfterReview': 'Ikke leveringspliktig etter faglig vurdering',
  'cye.nuf.notRequiredAfterReview': 'Ikke påkrevd etter faglig vurdering',
  'cye.nuf.required': 'Påkrevd',
  'cye.nuf.homeCurrency': 'Hjemvaluta',
  'cye.nuf.presentationCurrency': 'Presentasjonsvaluta',
  'cye.nuf.allocationMethod': 'Metode for resultatallokering',
  'cye.nuf.allocationEvidence': 'Dokumentasjon for resultatallokering',
  'cye.nuf.filingEvidence': 'Dokumentasjon for innsendingsplikter',
  'cye.nuf.openingBalance': 'Inngående mellomværende',
  'cye.nuf.transfersFrom': 'Overført fra hovedkontor',
  'cye.nuf.transfersTo': 'Overført til hovedkontor',
  'cye.nuf.allocatedResult': 'Allokert filialresultat',
  'cye.nuf.fxDifference': 'Valutadifferanse',
  'cye.nuf.closingBalance': 'Utgående mellomværende',
  'cye.nuf.branchAccountsPrepared': 'Filialregnskapet er utarbeidet',
  'cye.nuf.foreignAccountsPrepared': 'Utenlandsk årsregnskap er klart når det er påkrevd',
  'cye.nuf.professionalReviewConfirmed': 'Regnskaps-, skatte- og innsendingsvurderingen er faglig gjennomgått',
  'cye.nuf.expectedClosing': 'Forventet utgående mellomværende: {expected} · differanse {difference}',
  'cye.nuf.saving': 'Lagrer…',
  'cye.nuf.save': 'Lagre NUF-gjennomgang',
});
